import { render } from "./watcher.vue?vue&type=template&id=11a7c0fa"
import script from "./watcher.vue?vue&type=script&lang=js"
export * from "./watcher.vue?vue&type=script&lang=js"

import "./watcher.vue?vue&type=style&index=0&id=11a7c0fa&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__